<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Reset your password</h4>
                  <p>Please enter your new password below.</p>
                </div>
                <div class="mb-3">
                  <label for="New Password" class="text-xs">New Password *</label>
                  <vx-input-group class="w-full">
                    <vs-input
                      placeholder="Enter New Password"
                      v-validate="'required|min:8'"
                      :type="!form.showNewPassword && 'password'"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      v-model="form.password"
                      class="w-full"
                      data-vv-as="New Password"
                    />
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <vs-button
                          icon-pack="feather"
                          style="height: 60px !important; width: 80px !important"
                          :icon="form.showNewPassword ? 'icon icon-eye' : 'icon icon-eye-off'"
                          @click="form.showNewPassword = !form.showNewPassword"
                        />
                      </div>
                    </template>
                  </vx-input-group>

                  <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
                </div>
                <div class="mb-3">
                  <label for="Confirm Password" class="text-xs">Confirm Password *</label>
                  <vx-input-group class="w-full">
                    <vs-input
                      placeholder="Enter Confirm Password"
                      v-validate="'required|min:8'"
                      :type="!form.showConfirmPassword && 'password'"
                      name="Confirm Password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      v-model="form.confirm_password"
                      data-vv-as="Confirm Password"
                      class="w-full"
                    />
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <vs-button
                          icon-pack="feather"
                          style="height: 60px !important; width: 80px !important"
                          :icon="form.showConfirmPassword ? 'icon icon-eye' : 'icon icon-eye-off'"
                          @click="form.showConfirmPassword = !form.showConfirmPassword"
                        />
                      </div>
                    </template>
                  </vx-input-group>
                  <span class="text-danger text-sm" v-show="errors.has('Confirm Password')">{{ errors.first('Confirm Password') }}</span>
                </div>

                <div class="flex justify-between">
                  <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Back to Login</vs-button>
                  <vs-button id="reset-password" @click="save_changes" v-on:keyup.enter="save_changes" type="filled" class="px-4 w-full md:w-auto"> Reset Password </vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  data() {
    return {
      form: {
        password: '',
        confirm_password: '',
        showNewPassword: false,
        showConfirmPassword: false
      }
    }
  },

  /* Form Validate */
  computed: {
    ...mapState('common', ['loading']),
    validateForm() {
      return !this.errors.any()
    }
  },
  /* API Calling Function */
  methods: {
    ...mapActions('common', { resetPassword: 'resetPassword' }),

    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }

      try {
        const { password, confirm_password } = this.form
        if (password !== confirm_password) {
          this.$vs.notify({
            title: 'Error',
            text: 'Confirm Password Is Not Match',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          return
        }

        const rawToken = this.$route.query.token
        const token = rawToken ? decodeURIComponent(String(rawToken)).trim() : ''
        if (!token) {
          this.$vs.notify({
            title: 'Error',
            text: 'Invalid or missing reset link. Please request a new password reset email.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          return
        }
        const { message } = await this.resetPassword({ password, token })
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.$router.push(`/login`)
      } catch (message) {
        this.$vs.notify({
          title: 'Error',
          text: message.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  },

  /** watch */
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#reset-password',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#reset-password > .con-vs-loading')
      }
    }
  }
}
</script>
